import actions from "./actions";

const setIncidents = actions.setIncidents;
const setIncidentListVisible = actions.setIncidentListVisible;
const setIncidentsLoaded = actions.setIncidentsLoaded;
const setVisibleIncidents = actions.setVisibleIncidents;
const addSelectedIncident = actions.addSelectedIncident;
const removeSelectedIncident = actions.removeSelectedIncident;
const clearSelectedIncidents = actions.clearSelectedIncidents;
const setQueriedIncidentsTotal = actions.setQueriedIncidentsTotal;
const setDisplayedIncidentsCount = actions.setDisplayedIncidentsCount;

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  setIncidents,
  setIncidentsLoaded,
  setIncidentListVisible,
  setVisibleIncidents,
  addSelectedIncident,
  removeSelectedIncident,
  clearSelectedIncidents,
  setQueriedIncidentsTotal,
  setDisplayedIncidentsCount
};
